export const ErrorTypes = {
    CREDIT_LIMIT: 'CreditLimit',
    RATE_LIMIT: 'RateLimit',
};
